<template>
  <migration-details />
</template>

<script>
import MigrationDetails from '@/components/Migrations/MigrationDetails'

export default {
  name: 'MigrationView',
  components: {
    MigrationDetails
  }
}
</script>
